import { createStore } from 'vuex';
/* eslint-disable no-unused-vars */
// import createPersistedState from 'vuex-persistedstate';

import camera from './modules/camera';
import categories from './modules/categories';
import pos from './modules/pos';
import renderer from './modules/renderer';
import seatmap from './modules/seatmap';
import settings from './modules/settings';
import stats from './modules/stats';

type NameSpacedMutation<T extends string, U> = U extends Record<string, any>
  ? { [P in keyof U as `${T}/${P extends string ? P : never}`]: OmitFirstParam<U[P]> }
  : never;

// type that omits first parameter of given function typex
type OmitFirstParam<T> = T extends (x: any, ...args: infer P) => infer R ? (...args: P) => R : never;

type NameSpacedAction<T extends string, U> = U extends Record<string, any>
  ? { [P in keyof U as `${T}/${P extends string ? P : never}`]: OmitFirstParam<U[P]> }
  : never;

type NameSpacedGetters<T extends string, U> = U extends Record<string, any>
  ? { [P in keyof U as `${T}/${P extends string ? P : never}`]: ReturnType<U[P]> }
  : never;

// store type that includes all modules
type CustomStoreType = {
  state: {
    settings: (typeof settings)['state'];
    seatmap: (typeof seatmap)['state'];
    stats: (typeof stats)['state'];
    categories: (typeof categories)['state'];
    pos: (typeof pos)['state'];
    renderer: (typeof renderer)['state'];
    camera: (typeof camera)['state'];
  };
  getters: NameSpacedGetters<'settings', (typeof settings)['getters']> &
    NameSpacedGetters<'seatmap', (typeof seatmap)['getters']> &
    NameSpacedGetters<'stats', (typeof stats)['getters']> &
    NameSpacedGetters<'categories', (typeof categories)['getters']> &
    NameSpacedGetters<'pos', (typeof pos)['getters']> &
    NameSpacedGetters<'renderer', (typeof renderer)['getters']> &
    NameSpacedGetters<'camera', (typeof camera)['getters']>;

  _mutations: NameSpacedMutation<'settings', (typeof settings)['mutations']> &
    NameSpacedMutation<'seatmap', (typeof seatmap)['mutations']> &
    NameSpacedMutation<'stats', (typeof stats)['mutations']> &
    NameSpacedMutation<'categories', (typeof categories)['mutations']> &
    NameSpacedMutation<'pos', (typeof pos)['mutations']> &
    NameSpacedMutation<'renderer', (typeof renderer)['mutations']> &
    NameSpacedMutation<'camera', (typeof camera)['mutations']>;

  _actions: NameSpacedAction<'settings', (typeof settings)['actions']> &
    NameSpacedAction<'seatmap', (typeof seatmap)['actions']> &
    NameSpacedAction<'stats', (typeof stats)['actions']> &
    NameSpacedAction<'categories', (typeof categories)['actions']> &
    NameSpacedAction<'pos', (typeof pos)['actions']> &
    NameSpacedAction<'renderer', (typeof renderer)['actions']> &
    NameSpacedAction<'camera', (typeof camera)['actions']>;

  _modulesNamespaceMap: {
    'settings/': { state: (typeof settings)['state'] };
    'seatmap/': { state: (typeof seatmap)['state'] };
    'stats/': { state: (typeof stats)['state'] };
    'categories/': { state: (typeof categories)['state'] };
    'pos/': { state: (typeof pos)['state'] };
    'renderer/': { state: (typeof renderer)['state'] };
    'camera/': { state: (typeof camera)['state'] };
  };
};

const store = createStore({
  strict: !import.meta.env.PROD,
  state: {
    name: 'SquareMaze Seatmap Designer',
    version: '0.0.1',
  },
  modules: {
    settings,
    stats,
    categories,
    pos,
    seatmap,
    renderer,
    camera,
    // history,
  },
  getters: {
    motd: (state) => `${state.name} ${state.version}`,
    //   cameraSettings: (state) => state.settings.camera,
    //   settings: (state) => state.settings,
    //   statistics: (state) => state.stats,
    //   categories: (state) => state.categories,
    //   pos: (state) => state.pos,
    //   seatmap: (state) => state.seatmap,
    //   renderer: (state) => state.renderer,
  },
});

type StoreType = Omit<typeof store, 'getters'>;

export default store as StoreType & CustomStoreType;

export type Store = StoreType & CustomStoreType;
